import { InfoFieldValue } from 'shared/ui/common/InfoFieldValue'
import { DashboardRow } from 'shared/ui/common/DashboardRow'

import type { BigNumberish } from '@ethersproject/bignumber'
import { getPoolAssetIcon, PoolAsset } from 'modules/pools/constants/poolAssets'
import { formatAsset } from 'modules/pools/utils/formatAsset'
import * as links from 'modules/router/links'
import { Button } from 'shared/ui/controls/Button'

export type Collateral = {
  asset: PoolAsset
  amount: BigNumberish
}

type Props = {
  asset: PoolAsset
  totalAmount: string
  lockedAmount: string
  availableAmount: string
  className?: string
}

export function DashboardRowCollateral({
  asset,
  totalAmount,
  lockedAmount,
  availableAmount,
  className,
}: Props) {
  const isNoAvailableCollateral = Number(availableAmount) === 0
  return (
    <DashboardRow className={className}>
      <InfoFieldValue
        label="Asset"
        value={
          <>
            {getPoolAssetIcon(asset)} {asset}
          </>
        }
      />
      <InfoFieldValue
        label="Total deposited"
        tooltip={totalAmount}
        value={formatAsset(totalAmount, asset)}
        sign={asset}
      />
      <InfoFieldValue
        label="Locked"
        tooltip={lockedAmount}
        value={formatAsset(lockedAmount, asset)}
        sign={asset}
      />
      <InfoFieldValue
        label="Available"
        tooltip={availableAmount}
        value={formatAsset(availableAmount, asset)}
        sign={asset}
      />
      <Button
        link={{ pathname: links.collateral, search: 'action=withdraw' }}
        fashion="greenapple-ghost"
        size={40}
        isDisabled={isNoAvailableCollateral}
      >
        WITHDRAW
      </Button>
    </DashboardRow>
  )
}
